// @flow
import * as React from 'react';
export default function Footer(props) {
  return (
    <div>
      
    </div>
  );
};